import {ReduxStateType} from '../store';

export const selectPartners = (state: ReduxStateType) => {
  return state.partners;
};
